var widget_default = {
  "card": "l1RjE",
  "link": "_1RvW9",
  "container": "gDXSV",
  "image": "J--no",
  "right": "kYSRL",
  "cardLayout": "BEmk1",
  "content": "_6huMU",
  "title": "f6ScN",
  "subtitle": "VejYr",
  "button": "_5SsgP",
  "button_disabled": "KcZsy",
  "buttonText": "Ve92i",
  "slimLayout": "Hz7cQ",
  "contentText": "uJhwk"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
